export default {"src":"/_next/static/media/home-shake-icon.2b6b92c5.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};